import { AbstractControl, FormControl, FormGroup, ValidatorFn } from '@angular/forms'
import { LocalTimeRange } from '@ftr/contracts/type/shared'
import { LocalTime } from '@js-joda/core'
import { allOrNothing, isStartAfterEnd } from './time-range-control.validators'

export interface TimeRangeControlFormValue {
  start: LocalTime | null
  end: LocalTime | null
}

export interface TimeRangeControlForm {
  start: FormControl<LocalTime | null>
  end: FormControl<LocalTime | null>
}

/**
 * timeframe = default timeframe
 * input validation = individual fields, eg min/max times etc.
 * range validation = validation for the whole range (eg. checking for overlaps etc.)
 */
export class TimeRangeControl extends FormGroup<TimeRangeControlForm> {
  constructor(timeRange?: LocalTimeRange, inputValidation?: ValidatorFn[], rangeValidation?: ValidatorFn[]) {
    super(
      {
        start: new FormControl<LocalTime | null>(timeRange?.start ?? null, inputValidation),
        end: new FormControl<LocalTime | null>(timeRange?.end ?? null, inputValidation),
      },
      [isStartAfterEnd(), allOrNothing(inputValidation), ...(rangeValidation ?? [])],
    )
  }
}

export function isTimeRangeControl(control: AbstractControl): control is TimeRangeControl {
  return control instanceof TimeRangeControl
}

/**
 * Pretty key method. Given a "raw" form value, we can type check that it's got values for start and end.
 *
 * This means we can type as a valid LocalTimeRange after this check
 */
export function isFilledOut(timeRange: Partial<TimeRangeControlFormValue>): timeRange is LocalTimeRange {
  return !!timeRange?.start && !!timeRange?.end
}

export function isEmpty(timeRange: Partial<TimeRangeControlFormValue>): timeRange is LocalTimeRange {
  return !timeRange?.start && !timeRange?.end
}
